import React from 'react'

function Featured({image}) {
  return (
    <div> 
        <img src={image} alt=""></img>

    </div>
  )
}

export default Featured;